export default "__VITE_ASSET__3z89KvtimqkT_J0Jmj85iA__"